'use strict'

const defaults = require('./en')

module.exports = Object.assign({}, defaults, {
  message: {
    success: 'สำเร็จ',
    wait: 'wait',
    verify_code_sended: 'ส่งรหัสยืนยันเรียบร้อย',
    mobile_limit_quota: 'หมายเลขนี้ใช้งานเกินกำหนด',
    verify_code_waiting: 'โปรดรอสักครู่และดำเนินการอีกครั้ง',
    cannot_send_sms: 'ไม่สามารถส่งข้อความได้',
    notfound: 'ไม่พบข้อมูล'
  },
  validation: {
    login: {
      invalid: 'ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง'
    },
    username: {
      invalid: 'ชื่อผู้ใช้งานต้องเป็นตัวอักษร A-Z,a-z หรือ 0-9 เท่านั้น',
      required: 'กรุณากรอกชื่อผู้ใช้งาน',
      unique: 'มีผู้ใช้งานนี้ในระบบแล้ว',
      max_min: 'ชื่อผู้ใช้งานอย่างน้อย 6 - 30 ตัวอักษร',
    },
    password: {
      required: 'กรุณากรอกรหัสผ่าน',
      confirmed: 'ยืนยันรหัสผ่านไม่ถูกต้อง',
      max_min: 'รหัสผ่านไม่ถูกต้อง',
      same_username: 'รหัสผ่านจะต้องไม่เหมือนกับชื่อผู้ใช้งาน',
    },
    new_password: {
      required: 'กรุณากรอกรหัสผ่านใหม่',
      min: 'รหัสผ่านใหม่ไม่ถูกต้อง',
      max: 'รหัสผ่านใหม่ไม่ถูกต้อง',
      same_username: 'รหัสผ่านจะต้องไม่เหมือนกับชื่อผู้ใช้งาน',
    },
    confirm_new_password: {
      required_if: 'กรุณายืนยันรหัสผ่าน',
      same: 'กรุณายืนยันรหัสผ่านใหม่อีกครั้ง',
      min: 'รหัสผ่านใหม่ไม่ถูกต้อง',
      max: 'รหัสผ่านใหม่ไม่ถูกต้อง',
    },
    mobile: {
      required: 'กรุณากรอกหมายเลขโทรศัพท์',
      min: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
      max: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
    },
    number: {
      required: 'กรุณากรอกหมายเลขโทรศัพท์',
      numeric: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
    },
    security_code: {
      invalid: 'รหัสความปลอดภัยไม่ถูกต้อง'
    },
    verify_code: {
      invalid: 'รหัสยืนยันไม่ถูกต้อง'
    },
    partner: {
      invalid: 'ไม่สามารถสมัครสมาชิกได้ในขณะนี้'
    }
  }
})
